export enum EventActionType {
	SET_EVENT_FILTERS = 'SET_EVENT_FILTERS',
	SET_CUSTOM_FILTER_GROUPS = 'SET_CUSTOM_FILTER_GROUPS',
	SET_SHOW_EVENT_CREDENTIALS = 'SET_SHOW_EVENT_CREDENTIALS',
	SET_SELECTED_CUSTOM_FILTER_GROUPS = 'SET_SELECTED_CUSTOM_FILTER_GROUPS',
}
